import React, { useState, useEffect } from 'react';
import { Col, Card, Divider } from 'antd';
import ReactPlayer from 'react-player'
import { useHistory } from 'react-router-dom';
import { formatDate } from '../../utilities';

const VideoCard = ( props ) => {

  const history = useHistory();
  const  { nombre, descripcion, horario, id, url } = props.data;
  const [ fechaHoy, setFechaHoy ] = useState( new Date().getTime() )
  let fechaInicio = horario.toDate().getTime();

  useEffect( () => {
    setTimeout( () => {
        setFechaHoy( new Date().getTime() )
    }, 60000 - (new Date().getSeconds() * 1000)  );
  }, [ fechaHoy ] );

  return (
    <Col
      xs={{  span: 24, offset: 0 }} 
      sm={{  span: 24, offset: 0 }} 
      md={{  span: 12, offset: 0 }} 
      lg={{  span: 8, offset: 0 }}  
      xxl={{ span: 8, offset: 0 }}
      style={{ marginBottom: 30 }}
    >
      <Card
        onClick={ () => history.push(`/video?id=${id}`) }
        title={ nombre }
        hoverable
        style={{  minHeight: 430,}}
      >   
        <div className={ fechaHoy >= fechaInicio ? '' : 'blur-video' }>
          <ReactPlayer
              width='100%'
              height='190px'
              url={ url }
              controls={false}
              style={{ 
                pointerEvents: 'none', 
                filter: fechaHoy >= fechaInicio ? 'grayscale(0%)' : 'grayscale(100%)',
              }}
          />
        </div>
        <Divider  />
        <strong>Horario: </strong>{formatDate(horario.toDate())} <br />
        {descripcion}
      </Card>
    </Col>
  );
};

export default VideoCard;